
// 1. 安全获取数值
function parseSafe(value, defaultValue = 0) {
  let num = parseFloat(value);
  return isNaN(num) ? defaultValue : num;
}
// ========== 常量定义 ==========
  const INCH_TO_METER = 39.37;
  const SQINCH_TO_SQM = 1550; 
  const SQINCH_TO_SQFT = 144; 
  const SUC = 50;
  const R_TO_U = 6.5;
 

function getParm(fabricCode) {
  // 默认值
  const base = {
    PUC: 0,
    FUW: 0,
    WUW: 0,
    HUW: 0,
    MUC: 0,
    MUW: 0,
    MNIW: 0,
    PUW: 0.95,
    SSC: 0,
    Special: 0
  }; 

  // 产品配置映射
  const productMap = { 
    'SkylightShades': { ROLLER_TYPE: 'SkylightShades',  PUC: 210,  FUW: 0.33, MNIW: 2.3521, SSC: 350, MUC: 276,   MUW: 0.4, MIN_AREA_SQINCH: 208, WUW: 1.52, HUW: 1.44, PUW: 0.95, Special: 0 },
    'SkylightShades2': { ROLLER_TYPE: 'SkylightShades2',  PUC: 185,  FUW: 0.33, MNIW: 3.7996, SSC: 450, MUC: 552,   MUW: 0.8, MIN_AREA_SQINCH: 820, WUW: 3, HUW: 1.6, PUW: 0.95, Special: 0 },
    'SkylightShadesRemade': { ROLLER_TYPE: 'SkylightShadesRemade',  PUC: 210,  FUW: 0.33, MNIW: 1.9521, SSC: 300, MUC: 0,   MUW: 0, MIN_AREA_SQINCH: 208, WUW: 1.52, HUW: 1.44, PUW: 0.95, Special: 0 },

    '93037-T25': { ROLLER_TYPE: 'T25',  PUC: 160,  FUW: 0.25, MNIW: 1.9393, SSC: 320, MUC: 9,   MUW: 0.8, MIN_AREA_SQINCH: 156, WUW: 1.2, HUW: 1.2, PUW: 0.95, Special: 0 }, 
    'sleepguard': { ROLLER_TYPE: 'SleepGuard',  PUC: 160,  FUW: 0.25, MNIW: 1.9393, SSC: 320, MUC: 9,   MUW: 0.8, MIN_AREA_SQINCH: 156, WUW: 1.2, HUW: 1.2, PUW: 0.95, Special: 0 }, 
    // 'sleepguard': { ROLLER_TYPE: 'SleepGuard',  PUC: 125,  FUW: 0.33, MNIW: 1.3402, SSC: 300, MUC: 9,   MUW: 0.6, MIN_AREA_SQINCH: 96, WUW: 1.034, HUW: 0.614, PUW: 0.95, Special: 0 },  

    '82067M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 97,  FUW: 0.133, MNIW: 1.3312, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 1 },
    '82067':  { ROLLER_TYPE: 'RollerShades',  PUC: 78,  FUW: 0.133, MNIW: 2.2312, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 1 },

    '82082M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 106, FUW: 0.244, MNIW: 1.3613, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 1 },
    '82082':  { ROLLER_TYPE: 'RollerShades',  PUC: 87,  FUW: 0.244, MNIW: 2.2613, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 1 },

    '82083M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 116, FUW: 0.425, MNIW: 1.4103, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },
    '82083':  { ROLLER_TYPE: 'RollerShades',  PUC: 97,  FUW: 0.425, MNIW: 2.3103, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },

    '82167M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 112, FUW: 0.220, MNIW: 1.3548, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },
    '82167':  { ROLLER_TYPE: 'RollerShades',  PUC: 93,  FUW: 0.220, MNIW: 2.2548, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },

    '82168M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 126, FUW: 0.330, MNIW: 1.3846, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 1 },
    '82168':  { ROLLER_TYPE: 'RollerShades',  PUC: 107, FUW: 0.330, MNIW: 2.2846, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 1 },

    '82088M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 135, FUW: 0.434, MNIW: 1.4128, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },
    '82088':  { ROLLER_TYPE: 'RollerShades',  PUC: 96,  FUW: 0.434, MNIW: 2.3148, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },

    '82132M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 159, FUW: 0.467, MNIW: 1.4128, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },
    '82132':  { ROLLER_TYPE: 'RollerShades',  PUC: 125, FUW: 0.467, MNIW: 2.3217, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },

    '82180M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 128, FUW: 0.418, MNIW: 1.4084, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },
    '82180':  { ROLLER_TYPE: 'RollerShades',  PUC: 109, FUW: 0.418, MNIW: 2.3084, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },

    '82183M': { ROLLER_TYPE: 'Manual-RollerShades',  PUC: 130, FUW: 0.355, MNIW: 1.3913, SSC: 320, MUC: 0,   MUW: 0.0, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },
    '82183':  { ROLLER_TYPE: 'RollerShades',  PUC: 111, FUW: 0.355, MNIW: 2.2913, SSC: 350, MUC: 355, MUW: 0.9, MIN_AREA_SQINCH: 462, WUW: 1.3, HUW: 0, PUW: 0.95, Special: 0 },
    
    // 蜂巢帘 
    '93020TDBU':        { ROLLER_TYPE: 'CellularShades',  PUC: 174, FUW: 0.33, MNIW: 2.2859, SSC: 340, MUC: 478, MUW: 0.9, MIN_AREA_SQINCH: 500, WUW: 1, HUW: 0, PUW: 0.95, Special: 0 },
 
    '93021TDBU':        { ROLLER_TYPE: 'CellularShades',  PUC: 181, FUW: 0.33, MNIW: 2.2859, SSC: 340, MUC: 478, MUW: 0.9, MIN_AREA_SQINCH: 500, WUW: 1, HUW: 0, PUW: 0.95, Special: 0 },
 
    '93022TDBU':        { ROLLER_TYPE: 'CellularShades',  PUC: 205, FUW: 0.55, MNIW: 2.3540, SSC: 340, MUC: 478, MUW: 0.9, MIN_AREA_SQINCH: 500, WUW: 1, HUW: 0, PUW: 0.95, Special: 0 },
 
    '93023TDBU':        { ROLLER_TYPE: 'CellularShades',  PUC: 223, FUW: 0.55, MNIW: 2.3540, SSC: 340, MUC: 478, MUW: 0.9, MIN_AREA_SQINCH: 500, WUW: 1, HUW: 0, PUW: 0.95, Special: 0 },
 
    '93020DN':          { ROLLER_TYPE: 'CellularShades',  PUC: 213, FUW: 0.53, MNIW: 2.3479, SSC: 340, MUC: 478, MUW: 0.9, MIN_AREA_SQINCH: 650, WUW: 1, HUW: 0, PUW: 0.95, Special: 0 },
 
    '93021DN':          { ROLLER_TYPE: 'CellularShades',  PUC: 223, FUW: 0.53, MNIW: 2.3479, SSC: 340, MUC: 478, MUW: 0.9, MIN_AREA_SQINCH: 650, WUW: 1, HUW: 0, PUW: 0.95, Special: 0 },
 
    '93022DN':          { ROLLER_TYPE: 'CellularShades',  PUC: 285, FUW: 0.75, MNIW: 2.4160, SSC: 340, MUC: 478, MUW: 0.9, MIN_AREA_SQINCH: 650, WUW: 1, HUW: 0, PUW: 0.95, Special: 0 },
 
    '93023DN':          { ROLLER_TYPE: 'CellularShades',  PUC: 301, FUW: 0.75, MNIW: 2.4160, SSC: 340, MUC: 478, MUW: 0.9, MIN_AREA_SQINCH: 650, WUW: 1, HUW: 0, PUW: 0.95, Special: 0 }

  };

  // 合并默认值和特定配置
  return {
    ...base,
    ...(productMap[fabricCode] || {})
  };
}

function getCP(sqft,w,h, shadesType,tc,special){
  // 10. 计算 cp
  let cp=0.65;   
  //  console.log(w,h);
  switch (shadesType) {
    case 'SkylightShades':
      cp = 60;

      if ( sqft > 10 && h >= 80 ) {
        cp = h-20;        
      }  
      break;
    
    case 'SkylightShades2':
      if (sqft < 3) {
        cp = 145;
      } else if (sqft < 4) {
        cp = 150; 
      } else if (sqft < 5) {
        cp = 155; 
      } else {
        cp = 160;
      }

      break;

    case 'SkylightShadesRemade':
       cp = tc*0.1/6.5;
      break;
    
    case 'T25':
      // cp = sqft + 50;
      cp = tc*0.4/6.5;
      break;

    case 'SleepGuard':
      // cp = sqft + 50;
      cp = tc*0.4/6.5;
      break;

    case 'Manual-RollerShades':
      cp = tc*0.3/6.5;
      break;

    case 'RollerShades':
      cp = tc*0.3/6.5;
      break;
 
    case 'CellularShades':
      cp = tc*0.6/6.5;
      break;
  
    default:
      break;
  }

  return cp;
  
}

function calculatePrice(width, height, pPrice = 0, pProduct = null){ 
  // 1. 安全获取数值
  const w = parseSafe(width);
  const h = parseSafe(height);
  const productPrice = parseSafe(pPrice) || 0;
    
  let product = pProduct;  // 统一变量名
//  console.log('新方法',  w);
  // 如果没有传 product，尝试从全局获取 
  if (!product) {
    const priceEl = document.querySelector('.ymq_size') // 换成你显示价格的元素
    if (priceEl) priceEl.textContent = 'Please reselect the dimensions due to a system error.';
    return 1000; 
  }
  
  // 如果还是没有 product 或没有 tags，返回 0
  if (!product.tags) {
    const priceEl = document.querySelector('.ymq_size') // 换成你显示价格的元素
    if (priceEl) priceEl.textContent = 'Please reselect the dimensions due to a system error1.';
    return 1000; 
  }

  // if (!product) {
  //   product = window.product || window.Product || {};
  // }
  
  // // 如果还是没有 product 或没有 tags，返回 0
  // if (!product.tags) {
  //   console.error('calculatePrice: 无法获取 product 对象或 product.tags 不存在');
  //   return 0;  // 建议返回 0 而不是 1000
  // }

  
  let arrProductCode= ['SkylightShades','SkylightShades2','SkylightShadesRemade','93037-T25','sleepguard','82067M','82067','82082M','82082','82083M','82083','82167M','82167','82168M','82168','82088M','82088','82132','82180M','82180','82183M','82183','93020TDBU-Manual','93020TDBU','93021TDBU-Manual','93021TDBU','93022TDBU-Manual','93022TDBU','93023TDBU-Manual','93023TDBU','93020DN-Manual','93020DN','93021DN-Manual','93021DN','93022DN-Manual','93022DN','93023DN-Manual','93023DN'];
  // 如果只关心第一个匹配的值 
  let fabricCode = product.tags.find(tag => arrProductCode.includes(tag));
 
  let productDetails=getParm(fabricCode);  
 
  // 2. 定义常量  
  
  const ROLLER_TYPE = productDetails == null ? 'RollerShades' : productDetails.ROLLER_TYPE;  
  let special = productDetails == null ? 0 : productDetails.Special;  

  

  const MIN_AREA_SQINCH = productDetails == null ? 150 : productDetails.MIN_AREA_SQINCH;  
  const WUW = productDetails == null ? 2 : productDetails.WUW;  
  const HUW = productDetails == null ? 0 : productDetails.HUW;   
  const PUW = productDetails == null ? 1 : productDetails.PUW;  
  const PUC = productDetails == null ? 150 : productDetails.PUC;  
  const FUW = productDetails == null ? 0.5 : productDetails.FUW;  
  const MUC = productDetails == null ? 355 : productDetails.MUC; //手动没有，同时防止 productDetails拿不到，所以默认355
  const MUW = productDetails == null ? 0.9 : productDetails.MUW; //手动没有 
  const MNIW = productDetails == null ? 2.7 : productDetails.MNIW;  
  const SSC = productDetails == null ? 320 : productDetails.SSC;  

  // 3. 计算面积
  let areaSqInch = w * h;
    // console.log('w',  w);
    // console.log('h',  h);
  let sqft = areaSqInch / SQINCH_TO_SQFT;

  console.log('areaSqInch',areaSqInch);
  console.log('MIN_AREA_SQINCH',MIN_AREA_SQINCH);

  // 4. 面积不足返回 0
  // if (areaSqInch < MIN_AREA_SQINCH) return 0; 此部分不需要了
//  console.log(22222232323);
  // 5. 计算 pl
  let pl = 0;
  switch (ROLLER_TYPE) {
      
      case 'SkylightShades':
        pl = PUW * ((w > h ? w : h) / INCH_TO_METER + 0.1);
        break;

      case 'SkylightShades2':
        pl = PUW * ((w > h ? w : h) / INCH_TO_METER + 0.1);
        break;

      case 'SkylightShadesRemade':
        pl = PUW * ((w > h ? w : h) / INCH_TO_METER + 0.1);
        break; 

      case 'T25':
         pl = PUW * ((w > h ? w : h) / INCH_TO_METER + 0.1);
        break;

      case 'SleepGuard':
         pl = PUW * ((w > h ? w : h) / INCH_TO_METER + 0.1);
        break;
        
      case 'Manual-RollerShades':
         pl = PUW * (w / INCH_TO_METER + 0.1);
        break;
        
      case 'RollerShades':
         pl = PUW * (w / INCH_TO_METER + 0.1);
        break;
        
      case 'CellularShades':
         pl = PUW * (w / INCH_TO_METER + 0.1);
        break;

      default:
        pl = PUW * ((w > h ? w : h) / INCH_TO_METER + 0.1);
        break;
  }  
  // 6. 计算 pw
  let pw = FUW * w * h / SQINCH_TO_SQM 
          + WUW * w / INCH_TO_METER 
          + HUW * h / INCH_TO_METER  
          + MUW + pl;
 
  if( ROLLER_TYPE ==='T25' || ROLLER_TYPE === 'SleepGuard' ){
    if((w+h)*2/INCH_TO_METER > 6){
      pw = FUW * w * h / SQINCH_TO_SQM 
        + WUW * w / INCH_TO_METER 
        + HUW * h / INCH_TO_METER  
        + MUW * 2 + pl;
    }
  }        

  // 7. 计算 psc
  let psc = SSC + (pw - MNIW) / 0.5 * SUC;
  if(pw<MNIW) psc=SSC;
  // 8. 计算 pc
  let pc = (w * h <= SQINCH_TO_SQM) 
          ? PUC + MUC 
          : PUC * w * h / SQINCH_TO_SQM + MUC;

   if( ROLLER_TYPE ==='T25' || ROLLER_TYPE === 'SleepGuard' ){
    if((w+h)*2/INCH_TO_METER > 6){
      pc = (w * h <= SQINCH_TO_SQM) 
          ? PUC + MUC 
          : PUC * w * h / SQINCH_TO_SQM + MUC * 2;
    } 
  } 

  // 9. 计算 tc
  let tc = psc + pc;

  // 10. 计算 cp
  let cp=60; 
  cp=getCP(sqft,w,h,ROLLER_TYPE,tc,special);
 
  // 11. 计算最终价格
  let unitPrice = (tc/ R_TO_U +cp)/0.94/0.90 > productPrice ? (tc/ R_TO_U +cp)/0.94/0.90-productPrice : 0; 

    // console.log("33333");
    // console.log(tc,cp,psc,pc,pw);
 
  // console.log('unitPrice',unitPrice);
  // return   pw ;  
  return Math.round(unitPrice);
}
  
// 修改函数，不依赖外部传入这些变量
BlindsCalc = function(unit, product, shopify_product) {

    // 函数自己从 DOM 获取需要的值
    const getValue = (selector) => {
        const el = document.querySelector(selector);
        return el?.value || 0;
    };
     
    let widthInchValue, heightInchValue, widthCMValue, heightCMValue;
    
    if (unit === 'Centimeters') {
        // 只获取厘米值
        widthCMValue = getValue('.ymq_width_cm select');
        heightCMValue = getValue('.ymq_height_cm select');
        widthInchValue = widthCMValue * 0.393701;
        heightInchValue = heightCMValue * 0.393701;
    } else {
        // 只获取英寸值
        widthInchValue = getValue('.ymq_width_inch select');
        heightInchValue = getValue('.ymq_height_inch select');
    }
     
    return calculatePrice(widthInchValue, heightInchValue, product?.price, shopify_product);
}


BlockerCalc = function(unit) {
  // 函数自己从 DOM 获取需要的值
  const getValue = (selector) => {
      const el = document.querySelector(selector);
      return parseFloat(el?.value) || 0;
  };

  let length;

  if (unit === 'Centimeters') {
      // 使用厘米高度
      length = getValue('.ymq_height_cm select') * 0.393701;
  } else {
      // 使用英寸高度
      length = getValue('.ymq_height_inch select');
  }

  length = Math.round(length);

  // 设置最小值为 20
  if (length < 20) {
      return 20;
  }

  // 直接返回长度（如果需要上限可添加）
  return length;
}
 

// ========== ==========
  const api = Object.freeze({ 
    Shades:BlindsCalc, 
    Blinds:calculatePrice, 
    Blocker: BlockerCalc
  });
  
  if (typeof window.KURLAX === 'undefined') {
    Object.defineProperty(window, 'KURLAX', {
      value: api,
      writable: false,
      configurable: false
    });
  }
 